/** ESCHER FALLS — Bahasa Indonesia。 */

import type { Strings } from './ja';

export const ID: Strings = {
  pour: 'Alirkan',
  lever: 'Tuas',
  leverAria: 'Tarik tuas',
  retry: 'Mulai ulang',
  again: 'Sekali lagi',
  next: 'Lanjut',
  share: 'Bagikan gambar ini',
  shareFailed: 'Tidak bisa dibagikan',
  rotateLeft: 'Putar pandangan ke kiri',
  rotateRight: 'Putar pandangan ke kanan',
  tiltUp: 'Naikkan pandangan',
  tiltDown: 'Turunkan pandangan',
  topDown: 'Dari atas',
  water: (left, total) => `Air ${left} / ${total}`,
  moves: (left, total) => `Langkah ${left} / ${total}`,
  timeLeft: (time) => `Sisa ${time}`,
  drops: (n) => `${n} tetes`,

  resultClear: 'Mengalir',
  resultFail: 'Tidak mengalir',
  clearTitle: 'Airnya mengalir',
  fail: {
    time: 'Waktu habis',
    moves: 'Langkah habis',
    drywell: 'Air masuk ke sumur kering',
    water: 'Airnya habis',
    deadend: 'Air jatuh ke jalan buntu',
  },
  extendByAd: 'Tonton iklan untuk 30 detik lagi',
  extendByDrops: (cost) => `${cost} tetes untuk 30 detik lagi`,
  multiplyByAd: (mult) => `Tonton iklan untuk ×${mult} tetes`,

  stages: 'Tahap',
  settingsAria: 'Pengaturan',
  menuAria: 'Menu',
  back: 'Kembali',
  loop1: 'Putaran pertama',
  loop2: 'Putaran kedua',
  loopNote: 'Putaran kedua lebih ketat dalam langkah dan waktu. Catatannya disimpan terpisah.',
  shop: 'Toko',
  groupMain: 'Utama',
  groupExtra1: 'Ekstra',
  groupExtra2: 'Ekstra II',
  freeTrial: 'Gratis',
  notPurchased: (n, name) => `${n} ${name} (terkunci)`,
  lockedStage: 'Tahap terkunci',
  extraLockedFree: 'Tahap 1, “Air Terjun Terbalik”, gratis. Sisanya terbuka setelah dibeli dari Pengaturan (≡).',
  extraLocked: 'Terbuka setelah dibeli dari Pengaturan (≡).',
  extra2Locked: 'Tahap 11 dan seterusnya terbuka setelah air mengalir di tahap 1–10.',
  extra2LockedUnowned: 'Beli dari Pengaturan (≡), lalu selesaikan tahap 1–10 untuk membuka tahap 11 dan seterusnya.',
  extra2Note: 'Terbuka setelah air mengalir di semua tahap Ekstra.',
  progress: (cleared, total) => `Utama ${cleared} / ${total} selesai`,
  totalTime: (time) => `Total ${time}`,
  totalNone: 'Total —',

  settings: 'Pengaturan',
  bgm: 'Suara latar',
  se: 'Efek suara',
  testSound: 'Coba suaranya',
  audioStatus: (state) => `Suara: ${state}`,
  audioState: {
    locked: 'Belum aktif (sentuh layar sekali)',
    running: 'Berjalan',
    suspended: 'Dihentikan sementara',
  },
  demoNote: (n) => `${n} tahap ini demo web. Semua 42 tahap ada di aplikasi.`,
  demoGet: 'Unduh di App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'Tahap hari ini',
  dailyLoading: 'Memuat…',
  dailyOffline: 'Tidak tersambung, tahap hari ini tidak bisa dibuka',
  dailyPlay: 'Main',
  dailyCleared: (time: string) => `Selesai dalam ${time}`,
  archiveTitle: 'Tahap sebelumnya',
  upcomingTitle: 'Tahap mendatang',
  archiveLocked: '3 hari terakhir gratis. Beli Ekstra untuk membuka semua tahap yang lebih lama',
  language: 'Bahasa',
  languageAuto: 'Ikuti perangkat',
  palette: 'Palet warna',
  worn: 'Dipakai',
  owned: 'Dimiliki',
  buyDrops: 'Beli tetes',
  restore: 'Pulihkan pembelian',
  writeReview: 'Beri nilai aplikasi ini',
  moreApps: 'Karya lain dari pembuatnya',
  restoreChecking: 'Sedang memeriksa…',
  restoreDone: (n) => `${n} dipulihkan`,
  restoreNone: 'Tidak ada yang perlu dipulihkan',
  restoreFailed: 'Tidak bisa dipulihkan',
  chooseStage: 'Pilih tahap',
  resume: 'Lanjutkan',

  prizeLabel: 'Hadiah',
  awardLabel: 'Gelar',
  toExtra: 'Ke Ekstra',
  toLoop2: 'Ke putaran kedua',
  toStart: 'Ke awal',
  allClearTitle: 'Semua dilalui',
  allClearBody: (n) => `Air telah mengalir di semua ${n} saluran`,
  multiplyTimes: (mult) => `Tonton iklan untuk ×${mult}`,
  noteRank: 'Gelar tersimpan dalam catatan dan tampil di atas daftar tahap.',
  noteLoop2: 'Putaran kedua terbuka. Langkah dan waktu lebih ketat.',
  notePartOne: 'Sampai di sini Bagian Satu. Airnya belum naik.',
  inviteTry: 'Coba Ekstra 1',
  inviteOpen: 'Buka Ekstra I — 20 tahap',
  dateLine: (d) =>
    `${d.getDate()} ${['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'][d.getMonth()]} ${d.getFullYear()}`,

  completionTitle: 'Yang Melintasi Ketakterbatasan',
  rank: {
    none: '—',
    sovereign: 'Penguasa air',
    architect: 'Perancang air terjun',
    mason: 'Tukang batu',
    apprentice: 'Murid',
    wayfarer: 'Pejalan',
  },

  skin: {
    hakushi: 'Kertas kosong',
    ai: 'Indigo',
    koke: 'Lumut',
    shu: 'Merah vermilion',
    sumi: 'Tinta sumi',
  },

  product: {
    drops600: '600 tetes',
    drops1600: '1.600 tetes',
    drops5000: '5.000 tetes',
    noads: 'Hilangkan iklan',
    extras: 'Ekstra I — 21 tahap (tanpa iklan)',
  },
};
